import {logout} from "@/api/AuthApi";
import DiaryListConstants from "@/store/constants/diaryListRecords";
import html2pdf from "@/libs/html2pdf.bundle.js";
import DiaryListInternalData from "@/internalData/DiaryList";
import AuthButtons from "@/components/shared/AuthButtons";

export default {
  name: "NavBar",
  components: {
    AuthButtons
  },
  data() {
    return {
    };
  },
  methods: {
    printPage() {
      window.print();
    },
    logout() {
      logout();
    },
    getFormattedCurrentPageHTML(){
      const FRONT_SIZE =  document.createElement('style');
      FRONT_SIZE.innerText = `html{font-size: 11px;}`
      let doc = document.implementation.createHTMLDocument("");
      let printingElement = document.createElement("DIV");
      let headerElement = document.getElementById("filter-table-container").cloneNode(true);
      let bodyElement = document.getElementById("container-body").cloneNode(true);
      const valueSelection = this.getDocumentSelectValues()
      doc.body.appendChild(FRONT_SIZE);
      doc.body.appendChild(printingElement)

      printingElement.style.width = "1075px"      //width of canvas image
      headerElement.style.width = "100%"
      headerElement.style.paddingRight = "3rem"
      printingElement.appendChild(headerElement)
      printingElement.appendChild(bodyElement)


      // replace selection to div
      let selectElements = printingElement.getElementsByTagName("SELECT")
      let sizeElement = selectElements.length
      for(let i = 0;i<sizeElement;i++){
        let selectElement = selectElements[0]
        let value = valueSelection[i]
        let divToReplace = this.generateDivTemplate(selectElement, value)
        selectElement.parentElement.replaceChild(divToReplace, selectElement)
      }

      let commonInstruction = printingElement.querySelector("#text-note-container")
      let commonInstructionPrinting = printingElement.querySelector("#text-note-container-print")
      commonInstructionPrinting.classList.add("style-download-pdf")
      commonInstructionPrinting.classList.remove("print-common-intruction-print-function")
      commonInstruction.parentElement.replaceChild(commonInstructionPrinting, commonInstruction)
      // sign-table-pdf-border
      printingElement.getElementsByClassName("sign-table")[0].classList.add("sign-table-pdf-border")
      printingElement.getElementsByClassName("sign-table")[0].classList.remove("col-xl-10")
      //update style display
      const hideElements = printingElement.getElementsByClassName("print-d-none")
      const showElements = printingElement.getElementsByClassName("desktop-d-none")
      for(let hideElement of hideElements){
        hideElement.style.display = "none"
        //remove warn
        hideElement.removeAttribute("id")
      }
      for(let showElement of showElements){
        showElement.style.display = "block"
      }
      //remove plus icon
      const attachedImage = printingElement.getElementsByClassName("attached-image")
      attachedImage[[0]].style.marginRight = "3.9%"
      //remove last tr on left side
      const lastRows =  printingElement.getElementsByClassName("print-table-cell-right-none")
      for(let lastRow of lastRows){
        lastRow.classList.add("print-d-none-last-row")
        lastRow.classList.add("print-table-cell-right-none-download-pdf")
      }
      //remove last tr on workTable
      const workTable = printingElement.getElementsByClassName("table-work-contents")
      if(workTable.length>0){
        workTable[0].classList.add("print-d-none-last-row")
        workTable[0].classList.add("print-table-cell-left-none-download-pdf")
      }
      //remove min width workTable
      printingElement.getElementsByClassName("work-record-work-meeting-mastters")[0].classList.remove("work-record-work-meeting-mastters")
      printingElement.getElementsByClassName("hold-up-meeting")[0].classList.remove("hold-up-meeting")
      //set height Element attached image
      printingElement.getElementsByClassName("attached-image-content")[0].style.height = "170px"
      return doc
    },
    downPDF(){
      const doc = this.getFormattedCurrentPageHTML()
      //config pdf
      const opt = DiaryListInternalData.configHTML2Canvas
      html2pdf().set(opt).from(doc.body).toPdf().get('pdf').then(function (pdf) {
        const totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.setFontSize(10);
          pdf.setTextColor(150);
          pdf.text(i + '/' + totalPages, (pdf.internal.pageSize.getWidth()) - 0.4, (pdf.internal.pageSize.getHeight()-0.4));
        }
        pdf.setFont("Hiragino Kaku Gothic ProN")
      }).save();

    },
    getDocumentSelectValues(){
      const valueSelection  = []
      const originalSelections = document.getElementsByTagName("SELECT")
      for (let index = 0; index < originalSelections.length; index++) {
        const element = originalSelections[index];
        valueSelection.push(this.$_.get(element, ['selectedOptions',0,'innerText'], ""))
      }
      return valueSelection
    }
    ,generateDivTemplate(selectElement, originalValue){
      const divElement = document.createElement("DIV")
      divElement.className = "cus-print-div-pdf-cell"
      divElement.innerText = originalValue
      return divElement
    }
  },
  computed: {
    name() {
      return this.$store.getters[DiaryListConstants.GETTERS.getName];
    },
    isDashboard() {
      const currentURL = this.$route.path;
      return currentURL.includes("/dashboard");
    }
  }
};
